<template>
  <!-- <div class="px-4 py-8 flex justify-center">
    <a
      href="https://www.producthunt.com/posts/piceditor-io-all-in-one-photo-toolbox?embed=true&utm_source=badge-featured&utm_medium=badge&utm_source=badge-piceditor&#0045;io&#0045;all&#0045;in&#0045;one&#0045;photo&#0045;toolbox"
      target="_blank"
      ><img
        src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=966371&theme=light&t=1747411993363"
        alt="PicEditor&#0046;io&#0032;&#0045;&#0032;All&#0032;in&#0032;one&#0032;photo&#0032;toolbox - Smart&#0032;tools&#0032;to&#0032;edit&#0044;&#0032;enhance&#0032;&#0038;&#0032;perfect&#0032;your&#0032;images | Product Hunt"
        style="width: 250px; height: 54px"
        width="250"
        height="54"
    /></a>
  </div> -->

  <footer class="p-6 bg-slate-200 dark:bg-gray-900 z-30">
    <div class="mx-auto max-w-screen-xl">
      <div class="grid grid-cols-6 gap-8">
        <div class="col-span-6 lg:col-span-2 text-normal">
          <div class="text-lg">From 🇯🇵 with 🍣</div>
          <BuyMeACoffee class="mt-6" />
        </div>

        <div class="col-span-3 lg:col-span-2 text-center">
          <h3 class="uppercase lg:text-xl text-primary mb-4 font-bold">Other Products</h3>
          <ul class="text-sm flex flex-col gap-3 text-normal">
            <li>
              <a href="https://toolpro.dev" target="_blank" class="link">Dev Tools</a>
            </li>
            <li>
              <a href="https://checkip.dev" target="_blank" class="link">Network Tools</a>
            </li>
            <li>
              <a href="https://snapdownload.org" target="_blank" class="link">Video Download Tools</a>
            </li>
          </ul>
        </div>

        <div class="col-span-3 lg:col-span-2 text-right">
          <h3 class="uppercase lg:text-xl text-primary mb-4 font-bold">About Us</h3>
          <ul class="text-sm flex flex-col gap-3 text-normal">
            <li>
              <router-link :to="{ name: 'PageHelp', params: { slug: 'about' } }" class="link">About</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'PageHelp', params: { slug: 'terms-of-service' } }" class="link"
                >Terms of Service</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'PageHelp', params: { slug: 'privacy-policy' } }" class="link"
                >Privacy Policy</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'PagePricing' }" class="link">Pricing</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'PageFAQ' }" class="link">FAQ</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'PageContact' }" class="link">Contact</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <AdSenseFooter class="mt-4" />

    <div class="flex justify-center mt-4 pt-4 border-t border-gray-300 dark:border-gray-500 text-normal">
      <div>&copy; PicEditor 2024 - {{ new Date().getFullYear() }}</div>
    </div>
  </footer>
</template>

<script setup lang="ts">
  import BuyMeACoffee from '&/BuyMeACoffee.vue'
  import AdSenseFooter from '&/adsense/AdSenseFooter.vue'
</script>
